type LogoProps = {
  variant?: "dark" | "light";
  size?: "md" | "lg";
};

export default function Logo({ variant = "dark", size = "md" }: LogoProps) {
  const isLight = variant === "light";
  const emblemClass = isLight
    ? "bg-accent-500 text-background-50"
    : "bg-primary-500 text-background-50";
  const ringClass = isLight ? "ring-accent-500/25" : "ring-primary-500/25";
  const badgeClass = isLight
    ? "bg-background-50 text-accent-600"
    : "bg-background-50 text-primary-600";
  const wordClass = isLight ? "text-background-50" : "text-foreground-900";
  const subClass = isLight ? "text-background-50/80" : "text-foreground-500";
  const sizeClass = size === "lg" ? "w-12 h-12" : "w-11 h-11";
  const iconClass = size === "lg" ? "text-2xl" : "text-xl";
  const badgeSize = size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5";
  const arrowClass = size === "lg" ? "text-[11px]" : "text-[9px]";

  return (
    <a href="#beranda" className="flex items-center gap-2 md:gap-3 cursor-pointer">
      <span
        className={`relative ${sizeClass} flex items-center justify-center rounded-full ${emblemClass} ring-2 ring-offset-2 ${ringClass}`}
      >
        <span className="absolute inset-[3px] rounded-full border border-background-50/25" />
        <i className={`ri-user-3-fill ${iconClass} relative z-10`} />
        <span
          className={`absolute -top-0.5 -right-0.5 ${badgeSize} flex items-center justify-center rounded-full ${badgeClass}`}
        >
          <i className={`ri-arrow-up-line font-bold ${arrowClass}`} />
        </span>
      </span>
      <span className="flex flex-col leading-tight">
        <span className={`font-heading font-semibold text-sm md:text-base ${wordClass}`}>
          Kelab Kemajuan Insan
        </span>
        <span className={`text-[10px] md:text-xs tracking-widest uppercase ${subClass}`}>
          Malaysia
        </span>
      </span>
    </a>
  );
}